module.exports = __webpack_public_path__ + "static/media/befarings_bekreftelse.d184a4e1.jpg";